import { Grid, Paper, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { NumberFormat, SelectField } from '@roc/ui';
import { observer } from 'mobx-react';
import { PointsAndFeesAccordion } from './pointsAndFeesAccordion';

import { isNotBlank } from '@roc/feature-utils';
import { IQuoteTypeStore } from '../../stores/common/iQuoteTypeStore';
import { BrokerAccordion } from './brokerAccordion';
import { InterestRateSlider } from './interestRateSlider';
import { PercentagePicker } from './leverageComponents';
import { interestAccrualMethodOptions } from '../../utils/constants';

const useStyles = makeStyles(theme => ({
  paper: {
    border: `1px solid lightgray`,
    borderRadius: '16px !important',
    padding: theme.spacing(4),
  },
  tooltip: {
    backgroundColor: theme.palette.primary.main,
    fontSize: '1rem',
  },
}));

interface EconomicsCardProps {
  store: IQuoteTypeStore;
}

export const EconomicsCard = observer(({ store }: EconomicsCardProps) => {
  const classes = useStyles();
  const formStore = store.loanEconomicsStore.loanEconomicsFormStore;

  return (
    <Paper className={classes.paper} elevation={0}>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ paddingInline: '24px' }}>
          <Grid container spacing={2}>
            <Grid item xs={6} style={{ display: 'flex', justifyContent: 'center' }}>
              <PercentagePicker
                fieldName={'interestRate'}
                label="Borrower Interest Rate"
                value={formStore.form.fields.interestRate.value}
                min={5}
                max={20}
                onChange={value =>
                  formStore.onFieldChange('interestRate', value)
                }
              />
            </Grid>
            <Grid item xs={6} style={{ display: 'flex', justifyContent: 'center' }}>
              <InterestRateSlider store={store} minWidth='200px' />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ paddingInline: '24px' }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <SelectField
                label={'Interest Payment'}
                value={formStore.form.fields.interestAccrualMethod.value}
                options={store.loanEconomicsStore.interestAccrualMethodOptions ?? interestAccrualMethodOptions}
                onChange={value =>
                  formStore.onFieldChange('interestAccrualMethod', value)
                }
                fullWidth
                variant={'outlined'}
                standaloneLabel
                testId={'interestAccrualMethod'}
              />
            </Grid>
            <Grid item xs={6}>
              <NumberFormat
                label={'Loan Duration (in Months)'}
                variant="outlined"
                value={(
                  formStore.form.fields.loanTermMonths.value ?? ''
                ).toString()}
                onChange={e => {
                  formStore.onFieldChange(
                    'loanTermMonths',
                    parseInt(e.target.value)
                  );
                }}
                fullWidth
                row={true}
                testId={'loanTermMonths'}
                standaloneLabel={true}
                allowNegative={false}
                customInput={TextField}
                error={isNotBlank(formStore.form.fields.loanTermMonths.error)}
                errorText={formStore.form.fields.loanTermMonths.error}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <BrokerAccordion store={store} />
        </Grid>
        <Grid item xs={12}>
          <PointsAndFeesAccordion store={store} />
        </Grid>
      </Grid>
    </Paper>
  );
});
